'use strict';

var MOBILE_TABLET_MQ = '(max-width: 1024px)';

/**
 * Returns the lowest visible bottom edge among sticky header layers.
 * Mirrors pdpStickyBar.js so the bar stays below the header stack.
 */
function getLvzStickyHeaderBottom() {
	var maxBottom = 0;

	['lvz-header-info-container', 'lvz-header-template'].forEach(function (id) {
		var el = document.getElementById(id);
		if (!el) {
			return;
		}

		var rect = el.getBoundingClientRect();
		if (rect.height < 1) {
			return;
		}

		if (rect.bottom > maxBottom) {
			maxBottom = rect.bottom;
		}
	});

	return maxBottom;
}

/**
 * Mobile/tablet cart checkout CTA: fixed at the bottom until its natural position
 * enters the viewport, then docks in place. Lifts above the footer like the PDP bar.
 */
function initCartStickyCheckout() {
	var $anchor = $('[data-cart-sticky-checkout]');
	if (!$anchor.length) {
		return;
	}

	var $bar = $anchor.find('.checkout-continue');
	if (!$bar.length) {
		return;
	}

	var $cartPage = $anchor.closest('.cart-page');
	var footerEl = document.getElementById('footercontent');
	var mobileTabletMq = window.matchMedia(MOBILE_TABLET_MQ);
	var observer = null;
	var isStickyActive = false;
	var scrollTicking = false;

	function syncSpacerHeight() {
		if (!isStickyActive) {
			$anchor.css('minHeight', '');
			return;
		}

		var height = $bar.outerHeight() || 0;
		$anchor.css('minHeight', height + 'px');
	}

	function syncCssVarHeight() {
		var height = isStickyActive && mobileTabletMq.matches ? $bar.outerHeight() || 0 : 0;
		$('html').css('--lvz-cart-sticky-checkout-height', height + 'px');
	}

	function syncFooterOffset() {
		if (!isStickyActive || !mobileTabletMq.matches) {
			$bar.css({ bottom: '', transform: '' });
			syncCssVarHeight();
			return;
		}

		syncCssVarHeight();

		if (!footerEl) {
			$bar.css({ bottom: '0', transform: '' });
			return;
		}

		var innerH = window.visualViewport ? window.visualViewport.height : window.innerHeight;
		var footerTop = footerEl.getBoundingClientRect().top;
		var footerOffset = Math.max(0, innerH - footerTop);
		var barHeight = $bar.outerHeight() || 0;
		var headerBottom = getLvzStickyHeaderBottom();
		var headerMaxOffset = Math.max(0, innerH - barHeight - headerBottom);
		var offset = Math.min(footerOffset, headerMaxOffset);

		$bar.css({
			bottom: '0',
			transform: 'translateY(' + -offset + 'px)',
		});
	}

	function setStickyActive(active) {
		if (active === isStickyActive) {
			syncSpacerHeight();
			syncFooterOffset();
			if ($cartPage.length) {
				$cartPage.toggleClass('cart-page--sticky-checkout', active);
			}
			return;
		}

		isStickyActive = active;
		$bar.toggleClass('checkout-continue--sticky', active);

		if ($cartPage.length) {
			$cartPage.toggleClass('cart-page--sticky-checkout', active);
		}

		syncSpacerHeight();
		syncFooterOffset();
	}

	function evaluateStickyState(entry) {
		if (!mobileTabletMq.matches) {
			setStickyActive(false);
			return;
		}

		if (entry.isIntersecting) {
			setStickyActive(false);
			return;
		}

		if (entry.boundingClientRect.top > window.innerHeight) {
			setStickyActive(true);
			return;
		}

		setStickyActive(false);
	}

	function setupObserver() {
		if (observer) {
			observer.disconnect();
			observer = null;
		}

		if (!mobileTabletMq.matches || typeof IntersectionObserver === 'undefined') {
			setStickyActive(false);
			return;
		}

		observer = new IntersectionObserver(
			function (entries) {
				if (!entries.length) {
					return;
				}
				evaluateStickyState(entries[0]);
			},
			{
				threshold: 0,
			}
		);

		observer.observe($anchor[0]);
	}

	function onScrollOrResize() {
		if (!scrollTicking) {
			window.requestAnimationFrame(function () {
				scrollTicking = false;
				syncSpacerHeight();
				syncFooterOffset();
			});
			scrollTicking = true;
		}
	}

	function onBreakpointChange() {
		setupObserver();
		onScrollOrResize();
	}

	$(window).on('scroll.cartStickyCheckout resize.cartStickyCheckout', onScrollOrResize);

	if (window.visualViewport) {
		window.visualViewport.addEventListener('scroll', onScrollOrResize);
		window.visualViewport.addEventListener('resize', onScrollOrResize);
	}

	if (typeof mobileTabletMq.addEventListener === 'function') {
		mobileTabletMq.addEventListener('change', onBreakpointChange);
	} else if (typeof mobileTabletMq.addListener === 'function') {
		mobileTabletMq.addListener(onBreakpointChange);
	}

	$('body').on('cart:update.cartStickyCheckout', function () {
		window.requestAnimationFrame(function () {
			syncSpacerHeight();
			syncFooterOffset();
		});
	});

	setupObserver();
	onScrollOrResize();
}

module.exports = function () {
	initCartStickyCheckout();
};
